import DashboardPage from './DashboardPageContainer'

export default DashboardPage
